import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Empty } from 'antd';

const DistributionByWeekdayChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Empty description="Nenhum dado encontrado" />;
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="weekday" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`${value} lotes`, 'Total']}
        />
        <Legend />
        <Bar dataKey="totalBatches" name="Lotes" fill="#1890ff" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DistributionByWeekdayChart;

